import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BANNER_CONSTANTS } from '@commoncore/constants/bannerConstants';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';

@Component({
  selector: 'lib-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  public bannerTxt:any="";
  public bannerBtn:any="";
  public redirectUrl:any="";
  public showCloseButton:boolean = false;
  public bannersArray:any = [];
  localStorageService:any;
  sessionStorageService:any;
  router:any;
  @ViewChild('bannerContent') globalBanner: ElementRef;
  universalService: any;
  recalculateHeightService:any;
  cleverTapEventsService: any;

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(globalService);
  }

  ngOnInit(): void {
    var self = this;
  
    AppEvents.bannerEvent.subscribe(response => {
      var array = this.localStorageService.getBannerDetails(true);
      if(array){
        this.bannersArray = array;
      }else{
        this.bannersArray = [];
      }
      if(response["bannerType"] == BANNER_CONSTANTS.STORAGE_BANNER["bannerType"]){
        this.checkPercentageOfUsedStorage(response["forceShow"]?response["forceShow"]:false);
        return
      }
      response["bannerTxt"] = response["bannerTxt"]?response["bannerTxt"]:self.bannerTxt;
      response["bannerBtn"] = response["bannerBtn"]?response["bannerBtn"]:self.bannerBtn;
      response["redirectUrl"] = response["redirectUrl"]?response["redirectUrl"]:self.redirectUrl;
      response["showCloseButton"] = response["showCloseButton"];
      response["showBanner"] = response["showBanner"]?response["showBanner"]:true
      if(response["bannerTxt"] != ""){
        this.addBannerToArray(response,response["forceShow"]?response["forceShow"]:false);
      }
    })
  }

  setEnvObjects(globalService){
    this.router = globalService.getRouterRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.recalculateHeightService = globalService.getContainerHeightCalculatorService();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
  }

  closeBanner(banner){
      // e.stopPropagation()
      if(banner["bannerType"] == "freeUserAlmostFull" || banner["bannerType"] == "paidUserAlmostFull") {
        this.cleverTapEventsService.userQuotaEightyPercentFull("Close");
      } else if(banner["bannerType"] == "freeUserFull" || banner["bannerType"] == "paidUserFull") {
        this.cleverTapEventsService.userQuotaHundredPercentFull("Close");
      } else if(banner["bannerType"] == "paidPlanExpiry") {
        this.cleverTapEventsService.userPlanExpired("Close");
      }
      var findBanner = this.bannersArray.find(bnr=>bnr["bannerTxt"] == banner["bannerTxt"]);
      if(findBanner){
        var bannerIndex = this.bannersArray.indexOf(findBanner);
        if(bannerIndex >= 0){
          this.bannersArray[bannerIndex]["showBanner"] = false;
          this.updateLocalStorage(this.bannersArray);
          this.EmitEventForContainersToRecalculateHeight();
        }
      }
  }

  redirectUser(banner){
    if(banner["bannerType"] == "freeUserAlmostFull" || banner["bannerType"] == "paidUserAlmostFull") {
      this.cleverTapEventsService.userQuotaEightyPercentFull(banner["bannerBtn"]);
    } else if(banner["bannerType"] == "freeUserFull" || banner["bannerType"] == "paidUserFull") {
      this.cleverTapEventsService.userQuotaHundredPercentFull(banner["bannerBtn"]);
    } else if(banner["bannerType"] == "paidPlanExpiry") {
      this.cleverTapEventsService.userPlanExpired(banner["bannerBtn"]);
    }
    
    if(banner["redirectUrl"] == 'buystorage'){
      if(!ENV_CONSTANTS["constants"]["enableStoragePurchase"]){
        this.universalService.activeRepo == 'share' ? window.open(('/userprofile'),"_self", "noopener, noreferrer") : this.router.navigate(['/userprofile']) ;
        return
      }else{
        this.sessionStorageService.setBuyStorageAlreadyInitiated(true);
        this.universalService.activeRepo == 'share' ? window.open((banner["redirectUrl"]+"?skipback="),"_self", "noopener, noreferrer") : this.router.navigate(['/',banner["redirectUrl"]]);
        return
      }
    }
    this.universalService.activeRepo == 'share' ? window.open((banner["redirectUrl"]+"?skipback="),"_self", "noopener, noreferrer") : this.router.navigate(['/',banner["redirectUrl"]])
  }

  EmitEventForContainersToRecalculateHeight(){
    setTimeout(() => { 
      this.recalculateHeightService.sendRecalculateEventToComponents(true);
    }, 1000);
  }

  checkNoOfBannersBeingShownOnUI(banners){
    var bannersOnUI = banners.filter(element=>{
      return element.showBanner === true;
    })
    return bannersOnUI.length
  }

  addBannerToArray(banner,forceShow){
    var paidPlanExpiryBanner = this.bannersArray.find(bnr=>bnr["bannerType"] == ":paidPlanExpiry"); // this banner is hardcoded as there was a typo in the paidPlanExpiry text and after correcting the typo, there were 2 banners comming on the UI, so force deleting the old banner which has typo
    if(paidPlanExpiryBanner){
      var index = this.bannersArray.indexOf(paidPlanExpiryBanner);
      if(index >= 0){
        this.bannersArray.splice(index,1);
      }
    }
    var currentBannersOnUI = this.checkNoOfBannersBeingShownOnUI(this.bannersArray);
    var findBanner = this.bannersArray.find(bnr=>bnr["bannerType"] == banner["bannerType"]);
    if(!findBanner){
      this.bannersArray.push(banner);
    }else{
      var index = this.bannersArray.indexOf(findBanner);
      if(index >= 0){
        this.bannersArray[index]["bannerTxt"] = banner["bannerTxt"];
        this.bannersArray[index]["bannerBtn"] = banner["bannerBtn"];
        this.bannersArray[index]["redirectUrl"] = banner["redirectUrl"];
        this.bannersArray[index]["showCloseButton"] = banner["showCloseButton"];
        this.bannersArray[index]["bannerClassName"] = banner["bannerClassName"];
        this.bannersArray[index]["bannerIconType"] = banner["bannerIconType"];
        if(forceShow){
          this.bannersArray[index]["showBanner"] = true;
        }
      }
    }
    var bannersAfterAdding = this.checkNoOfBannersBeingShownOnUI(this.bannersArray);
    this.updateLocalStorage(this.bannersArray);
    if(currentBannersOnUI != bannersAfterAdding){
      this.EmitEventForContainersToRecalculateHeight();
    }
    this.EmitEventForContainersToRecalculateHeight();
  }

  updateLocalStorage(bannerDetails){
    this.localStorageService.setBannerDetails(bannerDetails)
  }

  checkPercentageOfUsedStorage(forceShow){
    var userData = this.localStorageService.getUserData(true);
    var bannerData;
    if(!userData){
      return
    }
    userData["allowStoragePurchase"] = userData["allowStoragePurchase"]?userData["allowStoragePurchase"]:"D";
    var quotaPercentage = (userData["quota"]["totalUsedQuota"]/userData["quota"]["totalAllocatedQuota"]) * 100;
    quotaPercentage = Math.round(quotaPercentage);
    this.checkIfPlanStatusIsActiveThenRemoveSubscriptionBanner(userData);

    if (quotaPercentage >= 80 && quotaPercentage < 100) {
      if (userData["allowStoragePurchase"] == "Y") {
        bannerData = BANNER_CONSTANTS.PAID_USER_QUOTA_EIGHTY_PERCENT_FULL;
        bannerData["forceShow"] = forceShow ? forceShow : false
        var text = bannerData["bannerTxt"].includes('%') ? bannerData["bannerTxt"].split('(')[0] + '( ' : bannerData["bannerTxt"];
        bannerData["bannerTxt"] = text + quotaPercentage + "%)"
        this.removeQuotaPartiallyFullBannerIfExists("freeUserFull");
        this.removeQuotaPartiallyFullBannerIfExists("paidUserFull");
        AppEvents.bannerEvent.next(bannerData)
      } else {
        bannerData = BANNER_CONSTANTS.FREE_USER_QUOTA_EIGHTY_PERCENT_FULL;
        bannerData["forceShow"] = forceShow ? forceShow : false
        var text = bannerData["bannerTxt"].includes('%') ? bannerData["bannerTxt"].split('(')[0] + '( ' : bannerData["bannerTxt"];
        bannerData["bannerTxt"] = text + quotaPercentage + "%)"
        this.removeQuotaPartiallyFullBannerIfExists("freeUserFull");
        this.removeQuotaPartiallyFullBannerIfExists("paidUserFull");
        AppEvents.bannerEvent.next(bannerData)
      }
    } else if(quotaPercentage >= 100){
      if(userData["allowStoragePurchase"] == "Y"){
        bannerData = BANNER_CONSTANTS.PAID_USER_QUOTA_FULL;
        bannerData["forceShow"] = forceShow ? forceShow : false
        this.removeQuotaPartiallyFullBannerIfExists("freeUserAlmostFull");
        this.removeQuotaPartiallyFullBannerIfExists("paidUserAlmostFull");
        AppEvents.bannerEvent.next(bannerData)
      }else{
        bannerData = BANNER_CONSTANTS.FREE_USER_QUOTA_FULL;
        bannerData["forceShow"] = forceShow ? forceShow : false
        this.removeQuotaPartiallyFullBannerIfExists("freeUserAlmostFull");
        this.removeQuotaPartiallyFullBannerIfExists("paidUserAlmostFull");
        AppEvents.bannerEvent.next(bannerData)
      }
    }else{
      this.removeQuotaPartiallyFullBannerIfExists("freeUserFull");
      this.removeQuotaPartiallyFullBannerIfExists("paidUserFull");
      this.removeQuotaPartiallyFullBannerIfExists("freeUserAlmostFull");
      this.removeQuotaPartiallyFullBannerIfExists("paidUserAlmostFull");
    }
  }

  removeQuotaPartiallyFullBannerIfExists(txt){
    var findBanner = this.bannersArray.find(bnr=>bnr["bannerType"] == txt);
    if(findBanner){
      var index = this.bannersArray.indexOf(findBanner);
      if(index>=0){
        this.bannersArray.splice(index,1);
        this.updateLocalStorage(this.bannersArray);
      }
    }
  }

  checkIfPlanStatusIsActiveThenRemoveSubscriptionBanner(userData){
    if(userData["paidPlan"] && userData["paidPlan"]["planStatus"] == "A"){ // remove subscription banner if the plan is active
      this.removeQuotaPartiallyFullBannerIfExists("paidPlanExpiry");
      this.updateLocalStorage(this.bannersArray);
    }
  }

}
